module.exports = __webpack_public_path__ + "assets/img/title.8fe2924c.png";